var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconAssuranceResponsive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 33,
    viewBox: "0 0 27 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.1478 19.4307H21.658C21.2292 19.4307 20.8065 19.5272 20.4231 19.7126L17.4476 21.1516C17.0642 21.337 16.6415 21.4334 16.2127 21.4334H14.6934C13.224 21.4334 12.0327 22.5856 12.0327 24.0069C12.0327 24.0642 12.0721 24.1148 12.1291 24.1306L15.8318 25.1539C16.4961 25.3374 17.2073 25.2735 17.8252 24.9745L21.0061 23.4364M12.0327 23.0718L5.33993 21.0166C4.15346 20.6471 2.87092 21.0851 2.1277 22.1139C1.59033 22.8576 1.80913 23.9228 2.59203 24.3743L13.544 30.69C14.2405 31.0916 15.0624 31.1896 15.8284 30.9624L25.1478 28.1985",
    stroke: "#FFFFFF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.7904 9.28228V6.95382C20.7904 5.6384 20.7904 4.98069 20.463 4.55158C20.1356 4.12247 19.3953 3.91414 17.9148 3.49749C16.9033 3.21283 16.0116 2.86988 15.2992 2.5568C14.3278 2.12994 13.8422 1.9165 13.4987 1.9165C13.1552 1.9165 12.6696 2.12994 11.6982 2.5568C10.9858 2.86988 10.0942 3.21282 9.08265 3.49749C7.60211 3.91414 6.86184 4.12247 6.53444 4.55158C6.20703 4.98069 6.20703 5.6384 6.20703 6.95382V9.28228C6.20703 13.7942 10.3088 16.5012 12.3596 17.5727C12.8514 17.8297 13.0973 17.9582 13.4987 17.9582C13.9001 17.9582 14.146 17.8297 14.6378 17.5727C16.6886 16.5012 20.7904 13.7942 20.7904 9.28228Z",
    stroke: "#FFFFFF",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAssuranceResponsive);
export default __webpack_public_path__ + "static/media/iconAssuranceResponsive.e0bb14880b6a1b774dfd0319e6de5465.svg";
export { ForwardRef as ReactComponent };